import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

const CHOICES_CONFIG_DEFAULT = {
  removeItemButton: true,
  placeholder: true,
  placeholderValue: "Выберите вариант",
  searchPlaceholderValue: "Введите текст для поиска...",
  loadingText: "Загрузка...",
  noResultsText: "Результаты не найдены",
  noChoicesText: "Нет вариантов для выбора",
  itemSelectText: "Нажмите для выбора",
  uniqueItemText: "Только уникальные",
  customAddItemText: "Можно добавлять только значения, соответствующие определенным условиям",
  searchResultLimit: 15
}

// Контроллер обязательно на СТАБИЛЬНОМ родителе <select>, а не на самом
// select'е: Choices.js при инициализации перемещает select внутрь своей
// обёртки — если data-controller висит на самом select'е, это перемещение
// триггерит disconnect()→destroy()→connect() по кругу (бесконечный цикл).
// См. kit_helper.rb#select_kit — рендерит именно такую обёртку.
export default class extends Controller {
  static targets = ["select"]

  connect() {
    const select = this.hasSelectTarget ? this.selectTarget : this.element.querySelector("select")
    this.choices = new Choices(select, CHOICES_CONFIG_DEFAULT)
    // Доступ из других контроллеров, которые дописывают <option> в select
    // напрямую (см. product_filter_controller.js) — как e.choices раньше.
    select.choices = this.choices
  }

  disconnect() {
    this.choices?.destroy()
  }
}
